import { Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiErrorInterceptor } from '@core/interceptors/api-error-interceptor';
import { LanguageInterceptor } from '@core/interceptors/language-interceptor';

export function provideHttpInterceptors(): Provider[] {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true }
  ];
}
